import Grid from '@material-ui/core/Grid'
import Select from 'Components/Select'
import Upload from 'Components/Upload'
import React from 'react'


export default class ComboSimpleDocument extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
            alignItems={'center'}>
        <Grid item xs
              style={{ margin: 0, padding: 5 }}>
          <Select style={this.props.style} inline={this.props.inline} title={this.props.title} options={this.props.options}
                  onChange={this.props.onChange}
                  disabled={this.props.disabled || false}
                  value={this.props.infoTiers === true && this.props.data !== undefined ? this.props.data.id : this.props.data}/>
        </Grid>
        {this.props.client_id &&
        <Grid item style={{ margin: 0, padding: 0 }}>
          <Upload disabled={this.props.disabled || false} media_id={data.valeur_entier} link={data.media_lien}
                  client_id={this.props.client_id} onChange={(r) => this.props.onChangeInput(r.id, r.media_lien)}/>
        </Grid>}
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboSimple/ComboSimpleDocument.js